<template>
  <div class="min-h-screen w-full pt-16">
    <main class="relative w-5/6 max-w-screen-lg rounded-2xl bg-blue-gray-50 shadow-xl p-5 mx-auto" style="min-height: calc(100vh - 8rem)">

      <h1 class="flex items-center text-xl font-bold uppercase mb-4 text-gray-700">
        <img src="/logo.png" class="w-10 h-10 mr-2" alt="2WEBP Optimizer Logo" />
        2WEBP Optimizer
      </h1>

      <form @submit.prevent="submit">
        <div class="flex flex-wrap">
          <div class="w-full lg:w-3/4 lg:pr-4 mb-6">
            <DropFile @input="addFile" />
            <FileList :files="files" @remove="removeFile" />
          </div>
          <div class="w-2/3 md:w-1/2 lg:w-1/4">
            <Settings @change="updateSettings" />
            <OptimizeButton :loading="loading" class="mt-6" />
          </div>
        </div>
        <div class="absolute bottom-0 left-0 w-full flex items-center">
          <div class="flex-grow py-4 px-4">
            <div ref="progress" :class="['h-6 rounded-md w-full transition-all', {'bg-yellow-300': loading, 'bg-green-400': completed}]" :style="{maxWidth: progressWidth + '%'}"><!-- progress --></div>
          </div>
        </div>
      </form>
    </main>
  </div>
</template>

<script>
import DropFile from './components/DropFile.vue'
import FileList from './components/FileList.vue'
import Settings from './components/Settings.vue'
import OptimizeButton from './components/OptimizeButton.vue'
import { v4 as uuidv4 } from 'uuid';
export default {
  components: {
    DropFile,
    FileList,
    Settings,
    OptimizeButton
  },

  data() {
    return {
      files: [],
      localFiles: {},
      settings: {},
      loading: false,
      completed: false,
      progressWidth: 0
    }
  },

  methods: {
    addFile(file) {
      this.files.push({
        fileEl: file,
        completed: false,
        uploading: false,
        uploaded: false,
        id: '',
        newFileName: '',
        downloadUrl: ''
      })
    },

    removeFile(idx) {
      this.files.splice(idx, 1);
    },

    updateSettings(settings) {
      this.settings = settings;
    },

    getFileStatus(id) {
      return fetch(process.env.VUE_APP_BE_URL + '/file-status?id=' + id, {
        method: 'GET',
        headers: {
          'Authorization': process.env.VUE_APP_ALLOW_HEADER,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error("It was not possible to get the file status")
          }
          return response;
        })
        .then(res => res.json())
        .then(res => {
          if (res.completed) {
            const file = this.files.find(f => f.id === id)
            file.completed = true;
            return this.getRetrieverPreSignedUrl(id)
              .then(res => {
                file.downloadUrl = res.url

                // this.saveStatusLocally(file);
              })
          } else {
            setTimeout(() => {
              return this.getFileStatus(id)
            }, 3000)
          }
        })
        .catch(err => console.log(err))
    },

    getRetrieverPreSignedUrl(id) {
      const query = new URLSearchParams({
        fileName: `${id}.zip`,
        fileType: 'application/zip',
        bucket: 'output'
      }).toString();

      return fetch(process.env.VUE_APP_BE_URL + '/retrieve?' + query,
        {
          headers: {
            'Authorization': process.env.VUE_APP_ALLOW_HEADER,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          if (!response.ok) {
            throw new Error("It was not possible to retrieve the pre signed url")
          }
          return response;
        })
        .then(res => res.json())
    },

    getPreSignedUrl(file) {
      const { fileEl } = file
      file.id = uuidv4();
      const blob = fileEl.slice(0, fileEl.size, fileEl.type);
      // var desired = stringToReplace.replace(/[^\w\s]/gi, '')
      // whitelist characters in the filename
      file.newFileName = `${file.id}.${fileEl.name.split(' ').join('-')}`;
      const newFile = new File([blob], file.newFileName, { type: fileEl.type });

      return fetch(process.env.VUE_APP_BE_URL + '/upload',
        {
          method: 'POST',
          headers: {
            'Authorization': process.env.VUE_APP_ALLOW_HEADER,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            fileName: newFile.name,
            fileType: newFile.type,
            metadata: {
              id: file.id,
              quality: String(this.settings.quality),
              widths: this.settings.widths.join('|')
            }
          })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error("It was not possible to retrieve the pre signed url")
          }
          file.uploading = true;
          return response;
        })
        .then(res => res.json())
    },

    uploadFile(file, url) {
      return fetch(url,
        {
          method: 'PUT',
          headers: {
            'Content-Type': file.fileEl.type
          },
          body: file.fileEl
        })
        .then(() => {
          file.uploading = false;
          file.uploaded = true
          return file;
        })
        .then(file => {
          setTimeout(() => {
            return this.getFileStatus(file.id)
          }, 3000)
        })
    },

    submit() {
      this.loading = true
      this.progressWidth = 0;
      // const h = setInterval(() => {
      //   this.progressWidth += 10
      //   if (this.progressWidth >= 100) {
      //     clearInterval(h)
      //     this.loading = false;
      //     this.completed = true;
      //   }
      // }, 500);

      this.files.filter(f => !f.uploaded).forEach(file => {
        this.getPreSignedUrl(file)
          .then(response => this.uploadFile(file, response.url))
          .catch(err => console.log(err))
      })

      const h = setInterval(() => {
        const isAllUploaded = this.files.filter(f => !f.uploaded).length === 0
        if (isAllUploaded) {
          this.loading = false;
          clearInterval(h)
        }
      }, 500)
    },

    saveFileStatusLocally(file) {
      let files = JSON.parse(window.localStorage.getItem('uploadedFiles')) || {};
      files[file.id] = {
        updated_at: new Date().getTime(),
        size: file.fileEl.size,
        downloadUrl: file.downloadUrl,
        id: file.id,
        quality: this.settings.quality,
        widths: this.settings.widths.join('|')
      }

      window.localStorage.setItem('uploadedFiles', JSON.stringify(files));
    },

    loadLocalFilesStatus() {
      this.localFiles = JSON.parse(window.localStorage.getItem('uploadedFiles'))
    }
  },

  mounted() {
    this.loadLocalFilesStatus()
  }
}
</script>
